import CustomButton from 'components/CustomInput/Button';
import CustomPagination from 'components/CustomPagination';
import CustomTable from 'components/CustomTable';
import TextHeader from 'components/CustomText/TextHeader';
import useArrangeMeeting from 'hooks/review/useArrangeMeeting';
import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components/macro';
import PageSize from 'components/CustomTable/PageSize';
import { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { GET_MEETING_ARRANGE_LIST } from 'store/key';

const SLayout = styled.div`
    padding: 15px;
`;

const ArrangeMeeting = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getMeetingArrangeList();
        // eslint-disable-next-line
    }, []);

    const getMeetingArrangeList = (newPage, newPageSize, newSort, newIsDesc) => {
        setIsLoading(true);
        const params = {
            page: newPage ?? page,
            pageSize: newPageSize ?? pageSize,
            sort: newSort ?? sort,
            isDesc: newIsDesc ?? isDesc,
        };

        dispatch({
            type: GET_MEETING_ARRANGE_LIST,
            payload: {
                params,
                callback: () => setIsLoading(false)
            },
        });
    };

    const {
        rows,
        columns,
        total,
        sort,
        isDesc,
    } = useArrangeMeeting({
        getMeetingArrangeList,
    });

    const changePageSize = async (value) => {
        setPageSize(value);
        getMeetingArrangeList(null, value, null, null);
    };

    const changePage = (value) => {
        setPage(value);
        getMeetingArrangeList(value, null, null, null);
    };

    return (
        <SLayout>
            <Grid container justify='space-between'>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <TextHeader>Meeting Arrangement List</TextHeader>
                    <CustomButton
                        style={{ marginLeft: 20 }}
                        onClick={() => {
                            history.push('/review/arrange-meeting');
                        }}
                    >
                        Add
                    </CustomButton>
                </div>
                <PageSize label={"Page Size"} value={pageSize} onChange={changePageSize} isLoading={isLoading} />
            </Grid>
            <div style={{ marginTop: 20 }}>
                <CustomTable columns={columns} rows={rows} loading={isLoading} />
            </div>

            <div style={{ marginTop: 20 }}>
                <CustomPagination
                    page={page}
                    pageSize={pageSize}
                    total={total}
                    isLoading={isLoading}
                    onPageChange={changePage}
                />
            </div>
        </SLayout>
    );
};

export default ArrangeMeeting;
